import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** 00:17:34 countdown that restarts automatically when it reaches zero. */
export function Countdown() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  const blocks = [{
    value: pad(hours),
    label: 'Hours'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Sec'
  }];
  return <div className="mt-5 flex flex-col items-center" data-id="element-18" data-mp="15b68uadra9uo">
      <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.15em] text-red-600 sm:text-xs" data-id="element-19" data-mp="15an3ru97ffy2">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="xytvkbtzet3m" />
        This offer expires in
      </p>
      <div className="mt-2 flex items-center gap-2" role="timer" aria-live="off" aria-label={`${pad(hours)} hours ${pad(minutes)} minutes ${pad(seconds)} seconds left`} data-id="element-21" data-mp="t093izovvfq9">
        {blocks.map(block => <div key={block.label} className="flex min-w-[62px] flex-col items-center rounded-xl bg-ink-deep px-3 py-2 shadow-lg" data-id="element-22" data-mp="f3di07rg3vtb">
            <span className="font-display text-2xl font-bold tabular-nums text-white sm:text-3xl" data-id="element-23" data-mp="o30lr07nddpj">
              {block.value}
            </span>
            <span className="text-[9px] font-semibold uppercase tracking-widest text-gold-light" data-id="element-24" data-mp="k0m2if02gbxq">
              {block.label}
            </span>
          </div>)}
      </div>
    </div>;
}